module.exports = __webpack_public_path__ + "img/solucion bucofaringea.32f88552.png";